<!--
 * @Author: RYL
 * @Description: 快速接入添加终端
 * @Date: 2020-10-10 18:20:34
 * @LastEditTime: 2022-03-23 14:34:07
-->
<template>
  <div class="add-terminal">
    <div>
      <!-- <el-radio-group v-model="radioValue" size="small">
        <el-radio-button label="已有终端"></el-radio-button>
        <el-radio-button label="新建终端"></el-radio-button>
      </el-radio-group> -->
    </div>
    <div style="margin-top: 30px" v-if="radioValue === '已有终端'">
      <TableComponent
        :Columns="Columns"
        height="400"
        :data="terminalList"
        :isChexkBox="false"
        :isRadio="true"
        radioLabel="id"
        @handleSelectionChange="handleSelectionChange"
        @GetStatus="GetStatus"
        :seek="seek"
      >
        <span
          slot="slot"
          slot-scope="scope"
          style="color:#409eff;font-size:15px;"
          >{{ scope.scope.$index }}</span
        >
        <span slot="customColumn" slot-scope="scope" style="font-size:15px;">{{
          protocolOptions[scope.scope.row.protocol.toString()]
        }}</span>
      </TableComponent>
      <pagination
        :total="total"
        :offset="offset"
        :limit="limit"
        @SizeChanges="SizeChanges"
        @CurrentChanges="CurrentChanges"
      ></pagination>
    </div>
    <div
      style="display: flex; justify-content: center;"
      v-else-if="radioValue === '新建终端'"
    >
      <!-- <terminal-form ref="terminalForm" :hasTemplate="false"></terminal-form> -->
      <el-form
        class="terminal-form"
        :model="terminalData"
        :rules="addRules"
        ref="addTerminal"
        label-width="140px"
        label-position="right"
      >
        <el-divider content-position="left">{{
          $t("lang.terminalList.Fillintheterminalinformation")
        }}</el-divider>
        <div class="continner">
          <el-form-item :label="$t('lang.terminalList.name')" prop="name">
            <el-input
              class="form-input"
              size="mini"
              v-model="terminalData.name"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.varlist.terminalType')" prop="name">
            <el-select
              v-model="terminalData.type"
              size="mini"
              @change="typeChange"
              clearable
            >
              <el-option value="0" label="Modbus"></el-option>
              <el-option value="1" label="IO Control"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('lang.terminalList.protocol')"
            prop="protocol"
          >
            <el-select
              class="form-input"
              size="mini"
              v-model="terminalData.protocol"
              @change="protocalChange"
            >
              <el-option
                v-for="(item, index) in protoOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('lang.terminalList.SlaveID')"
            prop="sid"
            v-if="terminalData.protocol != 3"
          >
            <el-input
              class="form-input"
              size="mini"
              v-model="terminalData.sid"
              clearable
            ></el-input>
            <div style="color: grey; line-height: 15px">
              {{ $t("lang.terminalList.Valuerange") + 255}}
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('lang.terminalList.Slaveaddress')"
            prop="ip"
            v-if="terminalData.protocol == 1"
          >
            <el-input
              class="form-input"
              size="mini"
              v-model="terminalData.ip"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('lang.terminalList.Port')"
            prop="port"
            v-if="terminalData.protocol == 1"
          >
            <el-input
              class="form-input"
              size="mini"
              v-model="terminalData.port"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('lang.terminalList.SerialportNo')"
            prop="com"
            v-if="terminalData.protocol == 2"
          >
            <el-select
              v-model="terminalData.com"
              clearable
              size="mini"
              class="form-input"
              :no-data-text="comText"
              @change="serialPortChang"
            >
              <el-option
                v-for="item in serialPortOptions"
                :key="item.sname"
                :label="item.sname"
                :value="item.sname"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-divider content-position="left" v-if="terminalData.protocol == 2">{{
          $t("lang.terminalList.Configureserialportinformation")
        }}</el-divider>
        <el-row v-if="terminalData.protocol == 2">
          <el-col :span="8">
            <el-form-item
              :label="`${$t('lang.smartlink.baudRate')}：`"
              prop="bps"
            >
              <el-select
                size="mini"
                v-model="terminalData.bps"
                clearable
                class="form-input"
              >
                <el-option
                  v-for="(item, index) in BaudRateList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="`${$t('lang.smartlink.dataBits')}：`"
              prop="dataBit"
            >
              <el-select
                allow-create
                filterable
                default-first-option
                size="mini"
                v-model="terminalData.dataBit"
                clearable
                class="form-input"
              >
                <el-option
                  v-for="(item, index) in DataBitList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="`${$t('lang.smartlink.stopBits')}：`"
              prop="stopBit"
            >
              <el-select
                size="mini"
                filterable
                allow-create
                default-first-option
                v-model="terminalData.stopBit"
                clearable
                class="form-input"
              >
                <el-option
                  v-for="(item, index) in StopBitList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="terminalData.protocol == 2">
          <el-col :span="8">
            <el-form-item
              :label="`${$t('lang.smartlink.checkBits')}：`"
              prop="checkBit"
            >
              <el-select
                size="mini"
                v-model="terminalData.checkBit"
                clearable
                class="form-input"
              >
                <el-option
                  v-for="(item, index) in CheckDigitList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="`${$t('lang.smartlink.flowControl')}：`"
              prop="xon"
            >
              <el-select
                class="form-input"
                size="mini"
                v-model="terminalData.xon"
                clearable
              >
                <el-option
                  v-for="(item, index) in FlowControlList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: center; margin-top: 50px">
      <el-button size="mini" @click="preStep">{{
        $t("lang.FastAccess.previous")
      }}</el-button>
      <el-button size="mini" type="primary" @click="next">{{
        $t("lang.FastAccess.next")
      }}</el-button>
    </div>
  </div>
</template>
<script>
import { PublicComponent } from "@/mixins/common";
import pagination from "@/components/pagination";
import TableComponent from "@/components/TableComponent/index";
import { Columns } from "./tableConfig";
import {
  getTerminalList,
  addTerminal,
  editTerminal,
  monitor,
  terminalDetail,
  queryTerminal,
  monitorTerminal,
} from "@/api/cloudMonitor/terminalList";
import { terminalForm } from "@/mixins/terminalForm";
import { cloneDeep, isEqual } from "lodash";
import {
  BaudRateList,
  DataBitList,
  StopBitList,
  CheckDigitList,
  FlowControlList,
} from "@/utils/com.js";
export default {
  mixins: [PublicComponent, terminalForm],
  props: ["deviceInfo"],
  components: {
    TableComponent,
    pagination,
  },
  mounted() {
    this.queryKeyword();
    console.log("???终端");
    console.log(this.deviceInfo);
    this.orignalDevice = cloneDeep(this.deviceInfo);
    console.log(this.orignalDevice);
    this.$emit("setTemplateFlag", true);
    if (this.deviceInfo.deviceId) {
      this.terminalData.device = this.deviceInfo;
      this.getConfig();
    }
  },
  data() {
    return {
      terminalList: [],
      // 协议
      protocolOptions: {
        "1": "Modbus TCP",
        "2": "Modbus RTU",
      },
      seek: {
        name: "",
        description: "",
        protocol: "",
      },
      Columns,
      radioValue: "新建终端",
      terminalSelections: [],
      orignalDevice: {},
      BaudRateList, //波特率选项
      DataBitList, //数据位选项
      StopBitList, //停止位选项
      CheckDigitList, //校验位选项
      FlowControlList, //流控选项
    };
  },
  watch: {
    radioValue() {
      this.clearData();
      if (this.radioValue === "已有终端") {
        this.$emit("setTemplateFlag", false);
      } else if (this.radioValue === "新建终端") {
        this.$emit("setTemplateFlag", true);
        if (this.deviceInfo.deviceId) {
          this.terminalData.device = this.deviceInfo;
          this.getConfig();
        }
      }
    },
    deviceInfo: {
      immediate: true,
      deep: true,
      handler(newDevice, oldDevice) {
        if (
          this.deviceInfo.deviceId &&
          newDevice.deviceId !== oldDevice.deviceId
        ) {
          this.terminalData.device = this.deviceInfo;
          if (this.radioValue === "新建终端") {
            this.getConfig();
          }
        }
      },
    },
    "terminalData.type": {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (newVal == 0) {
          this.protoOptions = [
            { label: "Modbus TCP", value: "1" },
            { label: "Modbus RTU", value: "2" },
          ];
          this.terminalData.protocol = "1";
        } else {
          this.protoOptions = [{ label: "IO Control", value: "3" }];
          this.terminalData.protocol = "3";
        }
      },
    },
  },
  methods: {
    // 获取终端详情封装数据进行发送编辑
    fetchDetail(id) {
      terminalDetail({ id })
        .then((res) => {
          if (res.data.code === 0) {
            this.handleData(res.data.data);
            // 处理采集配置模板的数据
            this.$set(this.terminalData, "template", { id: "" });
            this.$set(this.terminalData.template, "id", res.data.data.mid);
            this.$set(this.terminalData, "device", { deviceDid: "" });
            this.$set(this.terminalData.device, "deviceDid", res.data.data.did);
            this.$set(this.terminalData.device, "deviceSn", res.data.data.dsn);
            this.$set(
              this.terminalData.device,
              "deviceName",
              res.data.data.dname
            );
            let detailData = res.data.data;
            this.originalTemplate = this.terminalData.template;
            this.originalPotocol = this.terminalData.protocol;
            if (this.radioValue === "新建终端") {
              this.editOperation();
            } else {
              if (this.terminalData.did !== this.deviceInfo.deviceDid) {
                this.editOperation();
              } else {
                this.$emit("next");
              }
            }
          }
        })
        .catch(() => {});
    },
    iotConfig(action, id) {
      monitorTerminal({
        action,
        dtuId: id,
      }).then((res) => {
        console.log(res);
      });
    },
    // 发送编辑请求，修改数据
    editOperation() {
      this.terminalData.did = this.deviceInfo.deviceDid;
      let submitData = this.setSubmitData(this.terminalData);
      this.$set(submitData, "proType", this.originalPotocol);
      this.$set(submitData, "dsn", this.terminalData.device.deviceSn);
      editTerminal(submitData)
        .then((res) => {
          if (res.data.code === 0) {
            // 成功后要同时修改串口配置
            if (this.terminalData.protocol == 2) {
              this.updateCom();
            } else {
              this.$emit("next");
            }
            this.iotConfig(0, this.getData().id);
          } else {
            this.$message.error(this.$t("lang.FastAccess.Failedtoaddterminal"));
          }
        })
        .catch(() => {
          this.$message.error(this.$t("lang.alarmList.msg3"));
        });
    },
    // 协议发生变化
    protocalChange(val) {
      this.resetValidate();
    },
    next() {
      if (this.radioValue === "已有终端") {
        // 相当于编辑终端信息,这个时候只需要把终端下挂到设备上，不需选择模板
        if (this.terminalSelections.length <= 0) {
          this.$message.warning("请选择终端");
        } else {
          // 获取详情
          this.fetchDetail(this.terminalSelections[0].id);
        }
      } else if (this.radioValue === "新建终端") {
        // 在采集模板后添加和
        this.$refs["addTerminal"].validate((valid) => {
          if (valid) {
            this.terminalData.device = this.deviceInfo;
            this.$emit("next");
          } else {
            return false;
          }
        });
      }
    },
    // 修改串口配置
    updateCom() {
      if (this.terminalData.protocol == 2) {
        let arr = [
          {
            section: "serial",
            config: "smartlink",
            action: 0,
            index: [this.comIndex],
            options: {
              parity: this.terminalData.checkBit,
              data_bits: this.terminalData.dataBit,
              stop_bits: this.terminalData.stopBit,
              flow_ctrl: this.terminalData.xon,
              baudrate: this.terminalData.bps,
            },
          },
        ];
        updateConfig(
          this.terminalData.device.deviceSn,
          this.terminalData.device.deviceDid,
          arr
        )
          .then((res) => {
            if (res.data.code === 0) {
              this.$emit("next");
            } else {
              this.$message.error(
                this.$t("lang.terminalList.Serialportconfigurationfailed")
              );
            }
          })
          .catch(() => {
            this.$message.error(
              this.$t("lang.terminalList.Serialportconfigurationfailed")
            );
          });
      }
    },
    preStep() {
      this.$emit("preStep");
    },
    // 获取终端列表
    queryKeyword() {
      let params = {
        current: this.offset,
        size: this.limit,
      };
      queryTerminal(params)
        .then((res) => {
          if (res.data.code === 0) {
            let data = res.data.data;
            this.terminalList = data.records;
            this.terminalList.unshift({});
            this.total = data.total;
          } else {
            this.$message.error(this.$t("lang.terminalList.Requestfailed"));
          }
        })
        .catch(() => {
          this.$message.error(this.$t("lang.terminalList.Requestfailed"));
        });
    },
    //表格状态
    GetStatus(status) {
      return {
        status: status == 1 ? "success" : "danger",
        TagName:
          status == 1
            ? this.$t("lang.devicelist.connected")
            : this.$t("lang.devicelist.not"),
      };
    },
    // 表格复选框数据
    handleSelectionChange(val) {
      this.terminalSelections = [];
      this.terminalSelections.push(val);
    },
    // 返回终端选项数据
    getData() {
      if (this.radioValue === "已有终端") {
        return this.terminalSelections[0];
      } else if (this.radioValue === "新建终端") {
        // 终端信息要等选择了采集模板才能存到数据库
        return this.terminalData;
      }
    },
    typeChange(e) {
      this.$emit("typeChange", e);
    },
  },
};
</script>
<style scoped>
.form-input {
  width: 4rem;
}
.terminal-form {
  margin-top: 50px;
  width: 100%;
}
.add-terminal {
  margin-top: 50px;
}
.continner {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
</style>
